const UICheckbox =({checkboxTitle,checkboxVal,checkboxStatus})=>{

    return(<><label className={"mockTestV1PopUpReport-checkbox-outer  "}>
     <div className="mockTestTagsFont" style={{"marginLeft": "10px","marginTop": "0px" }} >{checkboxTitle}</div>   
      <input type={"checkbox"} 
       className="input-textbox" checked= {checkboxStatus} value={checkboxVal} name={checkboxVal}  
     onChange={e=>{  }}
   
    /><span class={"mockTestV1PopUpReport-square"}></span> </label>
    
    <style>{`
                            
/* The mockTestV1PopUpReport-checkbox-outer */
.mockTestV1PopUpReport-checkbox-outer {
  display: block;border-radius:10px;
  position: relative;border:3px solid #eee;padding:8px; margin:11px;
display:flex;justify-content:left;   padding-left: 35px;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 18px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default checkbox */
.mockTestV1PopUpReport-checkbox-outer input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.mockTestV1PopUpReport-square {
  position: absolute;
  top: 0;margin:8px;
  left: 0;
  height: 20px;
  width: 20px;border:2px solid #333;border-radius:5px;
  background-color: #eee;
}

/* On mouse-over, add a grey background color */
.mockTestV1PopUpReport-checkbox-outer:hover input ~ .mockTestV1PopUpReport-square {
  background-color: #ccc;
}

/* When the checkbox is checked, add a blue background */
.mockTestV1PopUpReport-checkbox-outer input:checked ~ .mockTestV1PopUpReport-square {
  background-color: rgba(144, 202, 249,1);
}

/* Create the mockTestV1PopUpReport-square/indicator (hidden when not checked) */
.mockTestV1PopUpReport-square:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the mockTestV1PopUpReport-square when checked */
.mockTestV1PopUpReport-checkbox-outer input:checked ~ .mockTestV1PopUpReport-square:after {
  display: block;
}

/* Style the mockTestV1PopUpReport-square/indicator */
.mockTestV1PopUpReport-checkbox-outer .mockTestV1PopUpReport-square:after {
  left: 7px;
  top: 1px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

    `}</style>
    
    </>)
}
export default UICheckbox